import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { GenericRESTPagedClientManager } from "../../../../js/lib/manager/GenericRESTPagedClientManager";
import { TLCRest } from "../../../../js/lib/rest/REST";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";

export class ReviewClientManager extends GenericRESTPagedClientManager {
  constructor(options) {
    super(
      $.extend(
        {
          resultsPanelId: LS2PAC_CONSTANTS.Ids.DetailsPage.reviewsContainer,
          restUrl: LS2PAC_CONSTANTS.restUrls.getReviews,
          pageSize: 5,
        },
        options
      )
    );

    this.restOptions.cache = false;

    this.addListeners();
  }
 
  onReviewTitle(event) {
    var success = false,
      response;
    TLCRest.jsonCall(LS2PAC_CONSTANTS.restUrls.reviewTitle, {
      postData: event.review,
      callback: function (data) {
        success = data.success;
        response = data;
      },
      finallyHandler: function () {
        TLCEventManager.fireEvent(
          LS2PAC_CONSTANTS.Events.onReviewTitleResponse,
          { success: success, response: response }
        );
      },
      cache: false,
      timeout: 10000,
    });
  }
  handleRemoveReview(_this) {
    return function (event) {
      var success = false;
      TLCRest.jsonCall(
        [LS2PAC_CONSTANTS.restUrls.removeReview, event.id, "remove"].join("/"),
        {
          type: "POST",
          callback: function (data) {
            success = true;
          },
          finallyHandler: function () {
            TLCEventManager.fireEvent(
              LS2PAC_CONSTANTS.Events.onRemoveReviewResponse,
              { success: success, id: event.id }
            );
          },
          cache: false,
          timeout: 10000,
        }
      );
    };
  }
  addListeners() {
    var _this = this;

    TLCEventManager.addListener(this.searchEvent, function (event) {
      _this.resetPageCache();
      _this.fireSearch(event);
    });

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onLogoutResponse,
      function (event) {
        _this.resetPageCache();
      }
    );

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onReviewTitle,
      function (event) {
        _this.onReviewTitle(event);
      }
    );

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onRemoveReview,
      this.handleRemoveReview(this)
    );
  }
  fireSearch(event) {
    this.search(
      event.resourceId,
      this.currentPage * this.pageSize,
      this.pageSize
    );
  }
  resetPageCache() {
    this.pages = [];
    this.hasResults = false;
    this.currentPage = 0;
  }
}
